import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    AttachmentDirectDownloadDetailDto
} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';


@Injectable({
  providedIn: 'root',
})
export class AttachmentDirectDownloadRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) {
  }

  // Returns URL with an exchange token that allows direct downloading of the attachment content.
  // Also returns the patientId, filename and mimetype of the attachment.
  getAttachmentDirectDownloadUrl(documentId: string): Observable<AttachmentDirectDownloadDetailDto> {
    const endpointUrl = `direct-download/attachments/${documentId}/url`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }


}
